export const theming = {
    carrefour: {
        colors: {
            location_icon_color: "#1E5BC6",
            active_offers_color: "#1E5BC6",
            links: {
                seeMore: "#1852cc"
            },
            menu: {
                icon: "#1E5BC6",
            },
            categories: {
                borderColor: "#1852cc"
            },

        },
        pages: {
            search: {
                searchIcon: "#1852cc",
                button: "#1852cc",
            },
            rescue: {
                button: "#1852cc",
            },
            terms: {
                actions: {
                    decline: {
                        button: "transparent",
                        text: "#1852cc",
                    }
                }
            },
            offer: {
                priceTextColor: "#1852cc",
                likeUpBg: "#E6ECF9",
                likeUpColor: "#1852cc",
                callToAction: "#1852cc"
            },
            categories: {
                itemBorderColor: "#1852cc"
            }
        },
        components: {
            productBox: {
                priceColor: "#1E5BC6"
            }
        },
        button: {
            background: "#1E5BC6",
            background_cancel: "red",
            color: "#FFFFFF"
        }
    },
    atacadao: {
        colors: {
            location_icon_color: "#266200",
            active_offers_color: "#266200",
            links: {
                seeMore: "#266200"
            },
            menu: {
                icon: "#266200",
            },
            categories: {
                borderColor: "#266200"
            }
        },
        pages: {
            search: {
                searchIcon: "#FF5A00",
                button: "#FF5A00",
            },
            rescue: {
                button: "#266200",
            },
            terms: {
                actions: {
                    decline: {
                        button: "transparent",
                        text: "#266200",
                    }
                }
            },
            offer: {
                priceTextColor: "#FF5A00",
                likeUpBg: "#e6ece3",
                likeUpColor: "#266200",
                callToAction: "#266200"
            },
            categories: {
                itemBorderColor: "#266200"
            }
        },
        components: {
            productBox: {
                priceColor: "#266200"
            }
        },
        button: {
            background: "#266200",
            background_cancel: "#E6E6E6",
            color: "#FFFFFF"
        }
    }
}